<div
  v-if="allowedFreeSamples && showTrigger"
  class="free-samples-block"
  :class="{
    'free-samples-block--border': hasBottomBorder
  }"
>
  <h2 v-if="isMobile" class="mobile-free-samples-block__title">{{ t('products.free_samples.title') }}</h2>
  <component
    :is="isMobile ? 'button' : 'div'"
    :type="isMobile ? 'button' : undefined"
    class="free-samples-block__trigger free-samples-block__trigger--clickable"
    @click="openModal"
  >
    <div class="free-samples-block__counter" aria-hidden="true">
      <span class="free-samples-block__count">{{ selectedSampleAmount }}</span>
    </div>
    <div class="free-samples-block__text">
      <div class="free-samples-block__title">{{ t('app.free_samples.title') }}</div>
      <p class="free-samples-block__subtitle">{{ subtitleText }}</p>
      <button v-if="!isMobile" type="button" class="free-samples-block__action" @click.stop="openModal">
        {{ selectedSampleAmount > 0 ? (t('app.free_samples.edit_samples') || 'Edit Samples') :
        (t('app.wishlist.add_now') || 'ADD NOW') }}
      </button>
    </div>
    <span v-if="isMobile" class="iconfont-arrow-right free-samples-block__arrow" aria-hidden="true" />
  </component>
</div>
